export default __webpack_public_path__ + "static/media/trash.29a600cf.svg";